import { Box, Center, Text } from '@chakra-ui/react';
import { useAuth } from '@invara-dev/react-base';
import React from 'react';

export const Home: React.FC = () => {
  const auth = useAuth();

  if (!auth.hasLoaded) {
    return (
      <Center h='100vh'>
        <Text>Loading...</Text>
      </Center>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <Center h='100vh'>
        <Box textAlign='center'>
          <Text fontSize='2xl' mb={4}>
            Welcome to the Compass Geomatics Database.
          </Text>
          <Text>Please log in to continue.</Text>
        </Box>
      </Center>
    );
  }

  return (
    <Center h='100vh'>
      <Box textAlign='center'>
        <Text fontSize='2xl' mb={4}>
          Welcome to the Compass Geomatics Database.
        </Text>
      </Box>
    </Center>
  );
};
